import { useState, useEffect } from "react";
import {
  Grid,
  Checkbox,
  FormControlLabel,
  Switch,
  Button,
  Typography
} from "@material-ui/core";
import ModalBase from "../../../global/ModalBase";
import HeaderModal from "../../../global/headerModal";
import { ModalRegionesStyle } from "./styles";

const ModalRegiones = ({
  open,
  handleClose,
  catalogoRegiones,
  setLPaqueteCircuitoRegion
}) => {
  const classes = ModalRegionesStyle();
  const [tempRegiones, setTempRegiones] = useState([]);

  // Resetear regiones al abrir el modal
  useEffect(() => {
    if (open) {
      const inicial = catalogoRegiones.map((region) => ({
        IdCatRegion: region.IdCatRegion,
        Descripcion: region.Descripcion,
        seleccionada: true, // Checkbox por default seleccionado
        IncluyeVuelo: true // Switch por default activado
      }));

      setTempRegiones(inicial);
    }
  }, [open, catalogoRegiones]);

  const handleCheckRegion = (IdCatRegion) => {
    const nuevasRegiones = tempRegiones.map((region) =>
      region.IdCatRegion === IdCatRegion
        ? { ...region, seleccionada: !region.seleccionada }
        : region
    );
    setTempRegiones(nuevasRegiones);
  };

  const handleSwitchVuelos = (IdCatRegion) => {
    const nuevasRegiones = tempRegiones.map((region) =>
      region.IdCatRegion === IdCatRegion
        ? { ...region, IncluyeVuelo: !region.IncluyeVuelo }
        : region
    );
    setTempRegiones(nuevasRegiones);
  };

  const handleGuardar = () => {
    const resultado = tempRegiones
      .filter((r) => r.seleccionada)
      .map((r) => ({
        IdCatRegion: r.IdCatRegion,
        IncluyeVuelo: r.IncluyeVuelo
      }));

    setLPaqueteCircuitoRegion(resultado);
    handleClose();
  };

  return (
    <ModalBase classes={classes} open={open} onClose={handleClose} style={{ width:"40rem"}}>
      <HeaderModal handleClose={handleClose} titulo="Seleccionar Regiones" />

      <Grid container spacing={2} className={classes.containerSpacing}>
        {tempRegiones.map((region) => (
          <Grid
            container
            key={region.IdCatRegion}
            alignItems="center"
            justifyContent="space-between"
            style={{
              borderBottom: "1px solid #ccc",
              padding: "8px 0"
            }}
          >
            {/* Checkbox para seleccionar la región */}
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={region.seleccionada}
                    onChange={() => handleCheckRegion(region.IdCatRegion)}
                    color="primary"
                  />
                }
                label={region.Descripcion}
              />
            </Grid>

            {/* Switch para indicar si incluye vuelo */}
            <Grid item xs={6} style={{ textAlign: "right" }}>
                <Typography
                    variant="body2"
                    display="inline"
                    style={{
                        color: !region.seleccionada ? "#aaa" : "#000"
                    }}
                >
                    {region.IncluyeVuelo ? "Tendrá vuelos" : "Solo terrestres"}
                </Typography>
                
                <Switch
                  color="primary"
                  checked={region.IncluyeVuelo}
                  onChange={() => handleSwitchVuelos(region.IdCatRegion)}
                  disabled={!region.seleccionada}
                />
            </Grid>
          </Grid>
        ))}
      </Grid>

      {/* Botones de acción */}
      <Grid container className={classes.buttonContainer} justifyContent="flex-end" spacing={2} >
        <Grid item>
          <Button onClick={handleClose} variant="outlined" color="secondary">
            Cancelar
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={handleGuardar} variant="contained" color="primary">
            Guardar
          </Button>
        </Grid>
      </Grid>
    </ModalBase>
  );
};

export default ModalRegiones;
